export {
  expandShorthandHexColor,
  isContrastReadable,
  prefixHexColor,
  stripHexPrefix,
} from '../../utils/color';

/** Default color palettes. */
export const naturalColorPalette = [
  '1976d2',
  '00796b',
  '2e7d32',
  'd4e157',
  'ffeb3b',
  'ffb74d',
  'ff8a65',
  'e57373',
  'b72367',
  '7e57c2',
] as const;

export const lighterColorPalette = [
  'bbdefb',
  'b2dfdb',
  'c8e6c9',
  'f0f4c3',
  'fff59d',
  'ffe0b2',
  'ffccbc',
  'ffcdd2',
  'efaecc',
  'd1c4e9',
] as const;

export const defaultColorPalette = [...naturalColorPalette, ...lighterColorPalette];
